export type PlatformResultBroadcast = {
  id: string;
  source: 'florida' | 'newyork';
  dayKey: string;
  window: 'day' | 'night';
  first: string;
  second: string;
  third: string;
  publishedAtMs: number;
};

function sourceLabel(source: string, es: boolean): string {
  if (source === 'newyork') return es ? 'Nueva York' : 'New York';
  if (source === 'florida') return 'Florida';
  return source;
}

function windowLabel(window: string, es: boolean): string {
  if (window === 'night') return es ? 'Noche' : 'Night';
  return es ? 'Día' : 'Day';
}

export function resultsTabTarget(role: string): string {
  if (role === 'banker' || role === 'lister' || role === 'god') {
    return `${role}:results`;
  }
  return `${role}:overview`;
}

export function buildPlatformResultInboxFields(
  row: PlatformResultBroadcast,
  lang: string,
  role: string,
) {
  const es = lang === 'es';
  const corrida = `${row.first} · ${row.second} · ${row.third}`;
  return {
    id: `results:${row.id}`,
    cat: 'results' as const,
    sev: 'success' as const,
    urgent: true,
    title: es ? 'Resultados publicados' : 'Results published',
    body: `${sourceLabel(row.source, es)} · ${windowLabel(row.window, es)} · ${corrida}`,
    meta: { target: resultsTabTarget(role), dayKey: row.dayKey, window: row.window },
  };
}
